import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';

interface DialogData {
  exp_id: string;
}
@Component({
  selector: 'app-receiptpreview',
  templateUrl: './receiptpreview.component.html',
  styleUrls: ['./receiptpreview.component.scss']
})
export class ReceiptpreviewComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ReceiptpreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData , private apiService: ApiService, private sanitizer:DomSanitizer,) {}
    imgSrc: SafeUrl | null = null;
  ngOnInit(): void {
    const imageUrl = "/hawdco/expense/"+ this.data.exp_id +"/proof"
   
    this.apiService.getBillProof(imageUrl).subscribe(blobData => {
      const unsafeImageUrl = URL.createObjectURL(blobData);
     this.imgSrc = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
     });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}
